module.exports = __webpack_public_path__ + "img/soundcloud.53551abe.png";